import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RecentlyFilledLoansComponent} from './recently-filled-loans/recently-filled-loans.component';

const routes: Routes = [{
    path: '',
    component: RecentlyFilledLoansComponent
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class InvestorCommonsRoutingModule {
}
